module.exports = __webpack_public_path__ + "img/logo.9f9922c6.jpeg";